"use client";

import { Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { Icon } from "@/components/ui/icon";
import { whoItsFor } from "@/lib/data/homepage";

/**
 * Who It's For — Audience cards with personas. Each card has a
 * stylized "persona" representation (initials in glass avatar),
 * name, title, and description.
 */
export function WhoItsFor() {
  const personaNames = ["Government", "Enterprise", "Campaign", "Public Figure", "Defense", "Finance"];
  const accents = [
    "var(--color-crimson)",
    "var(--color-purple)",
    "var(--color-amber)",
    "var(--color-gold)",
    "var(--color-emerald)",
    "var(--color-cyan)",
  ];
  return (
    <section id="who-its-for" className="relative section-pad">
      <Container>
        <Reveal className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full glass eyebrow-tiny text-[var(--color-amber)]">
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--color-amber)]" />
            Who It's For
          </span>
          <h2 className="mt-6">
            Trusted by the World's Leading Organizations
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {whoItsFor.map((a, i) => (
            <Reveal key={a.title} delay={i * 60}>
              <div
                className="rounded-2xl glass p-5 h-full relative overflow-hidden card-glow"
                style={{ ["--glow" as string]: accents[i] }}
              >
                <div className="flex items-center gap-3 mb-3">
                  {/* Persona avatar (initials) */}
                  <div
                    className="grid place-items-center h-12 w-12 rounded-full font-black text-base shrink-0"
                    style={{
                      background: `linear-gradient(135deg, ${accents[i]}, color-mix(in oklch, ${accents[i]} 60%, var(--color-purple)))`,
                      color: "white",
                      boxShadow: `0 6px 20px -8px ${accents[i]}`,
                    }}
                  >
                    {personaNames[i].split(" ").map((w) => w[0]).join("").slice(0, 2)}
                  </div>
                  <div>
                    <h3>{a.title}</h3>
                    <div className="eyebrow-tiny text-[rgb(var(--fg-subtle))] font-semibold mt-0.5">
                      Segment {i + 1} of 6
                    </div>
                  </div>
                </div>
                <p className="text-body-xs leading-relaxed text-[rgb(var(--fg-muted))]">{a.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}
